/* knowledge-cards-body.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"];
import "./knowledge-cards-body.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, lazy, memo, Suspense, useMemo, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Button, { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { SmartCardProvider as Provider } from '@atlaskit/link-provider';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { ProfileCardTrigger } from '@atlaskit/profilecard';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { descriptionHelper } from '../ai-answer-dialog/ai-answer-body/ai-answer-result/json/recent-work-list/description-helper';
import { useAIAnswerContext } from '../ai-answer-dialog/ai-answer-context';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../common/controller/analytics';
import { ErrorBoundary } from '../common/ui/error-boundary';
import { messages } from '../messages';
import { onKnowledgeCardLinkClick } from './analytics';
import { KnowledgeCardsRow } from './knowledge-cards-row';
import { PersonCard } from './person-knowledge-card/person-card';
import { KnowledgeCardsIntentType, KnowledgeCardsRowType } from './types';
import { useTeamsAppLinks } from './use-teams-app-links';
import { createProfileClient, trimARI } from './util';
var styles = {
  bodyContainer: "_kqswh2mm",
  fullInline: "_1bsb1osq",
  knowledgeCardsContent: "_n3td1b66"
};
var EmptyState = function EmptyState(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(Box, {
    paddingInline: "space.200",
    paddingBlock: "space.075"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, text));
};
var HoverCard = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_.smart-card/hover-card" */'@atlaskit/smart-card/hover-card').then(function (_ref2) {
    var HoverCard = _ref2.HoverCard;
    return {
      default: HoverCard
    };
  });
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
var CardContainer = forwardRef(function (_ref3, __cmplr) {
  var _ref3$as = _ref3.as,
    C = _ref3$as === void 0 ? TooltipPrimitive : _ref3$as,
    __cmpls = _ref3.style,
    __cmplp = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1ijo _4t3il3i9", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  CardContainer.displayName = 'CardContainer';
}
var EXPANDED_MAX_ITEMS_SHOWN = 6;
var MAX_ITEMS_SHOWN = 3;
export var KnowledgeCardsBody = /*#__PURE__*/memo(function (props) {
  var type = props.type,
    currentUserId = props.currentUserId,
    recommendedUsers = props.recommendedUsers,
    recentActivity = props.recentActivity,
    profileUrl = props.profileUrl,
    viewAllUrl = props.viewAllUrl;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    searcherId = _useAIAnswerContext.userDetails.id;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    formatDate = _useIntl.formatDate;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setExpanded = _useState2[1];
  var isPerson = type === KnowledgeCardsIntentType.PERSON;
  var _useTeamsAppLinks = useTeamsAppLinks({
      type: type,
      currentUserId: currentUserId,
      viewAllUrl: viewAllUrl,
      cloudId: commonAttributes.cloudId,
      teamId: type === KnowledgeCardsIntentType.TEAM ? props.teamId : undefined
    }),
    viewAllLink = _useTeamsAppLinks.viewAllLink,
    viewAllOnNavigate = _useTeamsAppLinks.viewAllOnNavigate,
    worksWithHref = _useTeamsAppLinks.worksWithHref,
    worksWithOnNavigate = _useTeamsAppLinks.worksWithOnNavigate,
    toUser = _useTeamsAppLinks.toUser;
  var profileClient = useMemo(function () {
    return createProfileClient(commonAttributes.cloudId);
  }, [commonAttributes.cloudId]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.bodyContainer
  }, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Inline, {
    space: "space.200"
  }, /*#__PURE__*/React.createElement(Stack, {
    grow: "fill",
    space: "space.050",
    xcss: styles.knowledgeCardsContent
  }, /*#__PURE__*/React.createElement(Box, {
    paddingInlineStart: "space.200",
    paddingBlockStart: "space.150",
    paddingInlineEnd: "space.300",
    paddingBlockEnd: "space.075"
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, formatMessage(messages.knowledge_cards_recent_work_subheader)), recentActivity.length > 0 && /*#__PURE__*/React.createElement(Link, {
    href: viewAllLink,
    appearance: "subtle",
    onClick: function onClick(e) {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'recent-work-view-all'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.RECENT_WORK_CLICKED
      });
      if (fg('platform-adopt-teams-nav-config')) {
        viewAllOnNavigate(e);
      }
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, formatMessage(messages.knowledge_cards_view_all_link))))), /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(Provider, null, !recentActivity.length ? /*#__PURE__*/React.createElement(EmptyState, {
    text: formatMessage(messages.knowledge_cards_recent_work_empty)
  }) : recentActivity.slice(0, !isExpanded ? MAX_ITEMS_SHOWN : Math.min(recentActivity.length, EXPANDED_MAX_ITEMS_SHOWN)).map(function (activity) {
    return /*#__PURE__*/React.createElement(HoverCard, {
      url: activity.url,
      key: "knowledge-card-activity-".concat(activity.url)
    }, /*#__PURE__*/React.createElement(KnowledgeCardsRow, {
      primaryText: activity.title,
      secondaryText: "".concat(activity.containerName, " \u2022 ").concat(descriptionHelper({
        currentUserId: searcherId || '',
        event: activity.event,
        contributors: activity.contributors,
        othersCount: activity.othersCount,
        formatMessage: formatMessage,
        formatDate: formatDate,
        timestamp: new Date(activity.timestamp)
      })),
      pictureUrl: activity.iconUrl,
      type: KnowledgeCardsRowType.WORK,
      onClick: function onClick() {
        fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          location: 'recent-work-item'
        })));
        fireSAINUsageEvent({
          metCriteria: SainAction.RECENT_WORK_CLICKED
        });
        window.open(activity.url, '_self', 'noopener, noreferrer');
      }
    }));
  }))))), /*#__PURE__*/React.createElement(Stack, {
    grow: "fill",
    space: "space.050",
    xcss: styles.knowledgeCardsContent
  }, /*#__PURE__*/React.createElement(Box, {
    paddingInlineStart: "space.200",
    paddingBlockStart: "space.150",
    paddingInlineEnd: "space.150",
    paddingBlockEnd: "space.075"
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignBlock: "center",
    xcss: styles.fullInline
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, isPerson ? formatMessage(messages.knowledge_cards_collaborators_subheader) : formatMessage(messages.knowledge_cards_team_members_subheader)), recommendedUsers.length > 0 && /*#__PURE__*/React.createElement(Link, {
    href: isPerson ? fg('platform-adopt-teams-nav-config') ? worksWithHref : "https://hello.atlassian.net/people/".concat(currentUserId || '', "#workswith") : viewAllLink,
    appearance: "subtle",
    onClick: function onClick(e) {
      if (isPerson) {
        fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          location: 'reporting-lines-link'
        })));
        fireSAINUsageEvent({
          metCriteria: SainAction.REPORTING_LINES_CLICKED
        });
        if (fg('platform-adopt-teams-nav-config')) {
          worksWithOnNavigate(e);
        }
      } else {
        fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
          location: 'recent-work-view-all'
        })));
        fireSAINUsageEvent({
          metCriteria: SainAction.RECENT_WORK_CLICKED
        });
        if (fg('platform-adopt-teams-nav-config')) {
          viewAllOnNavigate(e);
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, formatMessage(messages.knowledge_cards_view_all_link))))), !recommendedUsers.length ? /*#__PURE__*/React.createElement(EmptyState, {
    text: formatMessage(isPerson ? messages.knowledge_cards_collaborators_empty : messages.knowledge_cards_teammembers_empty)
  }) : recommendedUsers.slice(0, !isExpanded ? MAX_ITEMS_SHOWN : Math.min(recommendedUsers.length, EXPANDED_MAX_ITEMS_SHOWN)).map(function (user) {
    var userUrl = "/people/".concat(trimARI(user.accountId || ''));
    if (fg('kd_platform_person_cards')) {
      return /*#__PURE__*/React.createElement(ProfileCardTrigger, {
        userId: trimARI(user.accountId || ''),
        resourceClient: profileClient,
        actions: [{
          label: formatMessage(messages.knowledge_cards_person_hover_profile_link),
          link: toUser(user.accountId || '').href,
          callback: function callback(e) {
            toUser(user.accountId || '').onNavigate(e);
          }
        }]
      }, /*#__PURE__*/React.createElement(KnowledgeCardsRow, {
        primaryText: user.name,
        secondaryText: !!user.title || !!user.department ? [user.title, user.department].filter(function (str) {
          return !!str;
        }).join(', ') : '',
        pictureUrl: user.picture || '',
        type: KnowledgeCardsRowType.PERSON,
        onClick: function onClick(e) {
          fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
            location: 'user-list-item'
          })));
          fireSAINUsageEvent({
            metCriteria: SainAction.TEAM_MEMBER_CLICKED
          });
          if (fg('platform-adopt-teams-nav-config')) {
            toUser(user.accountId || '').onNavigate(e);
          } else {
            window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
          }
        }
      }));
    }
    return /*#__PURE__*/React.createElement(Tooltip, {
      key: user.accountId,
      position: "bottom-end"
      // @ts-ignore -- `styled(TooltipPrimitive)` is not valid for `component` (and fails in Jira)
      ,
      component: CardContainer,
      content: /*#__PURE__*/React.createElement(PersonCard, {
        key: user.accountId,
        name: user.name,
        profilePicUrl: user.picture || '',
        accountId: user.accountId || '',
        jobTitle: user.title,
        profileUrl: user.url || userUrl,
        email: user.email
      })
    }, function (triggerProps) {
      return /*#__PURE__*/React.createElement(KnowledgeCardsRow, {
        primaryText: user.name,
        secondaryText: !!user.title || !!user.department ? [user.title, user.department].filter(function (str) {
          return !!str;
        }).join(', ') : '',
        pictureUrl: user.picture || '',
        type: KnowledgeCardsRowType.PERSON,
        triggerProps: triggerProps,
        onClick: function onClick(e) {
          fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
            location: 'user-list-item'
          })));
          fireSAINUsageEvent({
            metCriteria: SainAction.TEAM_MEMBER_CLICKED
          });
          if (fg('platform-adopt-teams-nav-config')) {
            toUser(user.accountId || '').onNavigate(e);
          } else {
            window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
          }
        }
      });
    });
  }))), /*#__PURE__*/React.createElement(Box, {
    paddingInline: "space.200",
    paddingBlockStart: "space.050",
    paddingBlockEnd: "space.075"
  }, recommendedUsers.length > MAX_ITEMS_SHOWN || recentActivity.length > MAX_ITEMS_SHOWN ? /*#__PURE__*/React.createElement(Inline, {
    alignInline: "center",
    space: "space.025"
  }, isExpanded ? /*#__PURE__*/React.createElement(LinkButton, {
    href: profileUrl || '',
    onClick: function onClick() {
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'footer-view-all'
      })));
      fireSAINUsageEvent({
        metCriteria: isPerson ? SainAction.VIEW_PROFILE_CLICKED : SainAction.VIEW_TEAM_PAGE_CLICKED
      });
    },
    spacing: "compact",
    appearance: "subtle"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest",
    weight: "medium"
  }, isPerson ? formatMessage(messages.ai_answer_who_questions_view_profile) : formatMessage(messages.knowledge_cards_view_team))) : /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      setExpanded(function (e) {
        return !e;
      });
      fireAnalyticsEvent(onKnowledgeCardLinkClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        location: 'show-more'
      })));
      fireSAINUsageEvent({
        metCriteria: SainAction.EXPAND_CLICKED
      });
    },
    spacing: "compact",
    appearance: "subtle"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtlest",
    weight: "medium"
  }, formatMessage(messages.ai_answer_expand_button_label)))) : null)));
});